<template>
  <!-- begin sidebar nav -->
  <ul class="nav" v-if="menus">
    <li>
      <div class="switcher-apps">
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_10198_13764)">
            <path
              d="M18 4.5H12.6667C11.564 4.5 10.6667 5.39733 10.6667 6.5V20.5H20V6.5C20 5.39733 19.1027 4.5 18 4.5ZM18.6667 19.1667H12V6.5C12 6.13267 12.2993 5.83333 12.6667 5.83333H18C18.3673 5.83333 18.6667 6.13267 18.6667 6.5V19.1667ZM7.33333 6.5H8.66667V18.5H7.33333V6.5ZM4 8.5H5.33333V16.5H4V8.5Z"
              fill="#383838"
            />
          </g>
          <defs>
            <clipPath id="clip0_10198_13764">
              <rect width="16" height="16" fill="white" transform="translate(4 4.5)" />
            </clipPath>
          </defs>
        </svg>

        <div class="application-list">
          <span>AHM Product</span>

          <select v-model="currentApp" @change="handleAppSwitch">
            <option v-if="currentAppName" :value="currentApp" disabled>
              {{ currentAppName }}
            </option>
            <option v-for="app in switchApps" :key="app.id" :value="app.id">
              {{ app.name }}
            </option>
          </select>
        </div>
      </div>
    </li>
    <li class="nav-header">Navigation</li>
    <template v-for="menu in menus">
      <sidebar-nav-list
        ref="sidebarNavList"
        v-bind:menu="menu"
        v-bind:badges="badges"
        v-bind:scrollTop="scrollTop"
        v-bind:status="menu.status"
        v-on:collapse-other="handleCollapseOther(menu)"
        v-on:showFloatSubmenu="handleShowFloatSubmenu"
        v-on:hideFloatSubmenu="handleHideFloatSubmenu"
      ></sidebar-nav-list>
    </template>
    <!-- begin sidebar minify button -->
    <li>
      <a href="javascript:;" class="sidebar-minify-btn" v-on:click="handleSidebarMinify()">
        <i class="fa fa-angle-double-left"></i>
      </a>
    </li>
    <!-- end sidebar minify button -->
  </ul>
  <!-- end sidebar nav -->
</template>

<script>
import SidebarMenu from "./SidebarMenu.vue";
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions.js";

export default {
  name: "SidebarNav",
  props: ["scrollTop"],
  components: {
    SidebarNavList,
  },
  data() {
    return {
      menus: SidebarMenu,
      badges: { needsResubmission: 0 },
      pageOptions: PageOptions,
      modules: [],
      user: this.$store.getters.currentUser,
      productCategories: this.$store.getters.getProductCategory,
      categoryIdMap: [],
      currentApp: null,
      /* categoryIdMap: {
        oil: 1,
        "pad;shoe": 2,
        vanbelt: 3,
        oil_gear: 5,
      }, */
    };
  },
  created() {
    console.log("data created");
    this.getAllApps();
    this.loadBadges();
    this.$root.$on("ds-badge", this.setBadge);
    this.$root.$on("ds-badge-reset", this.loadBadges);
  },
    beforeDestroy() {
      this.$root.$off("ds-badge", this.setBadge);
      this.$root.$off("ds-badge-reset", this.loadBadges);
  },
  mounted() {
    // this.getModules();
  },
  computed: {
    switchApps() {
      return this.productCategories;
    },
    currentAppName() {
      if (!this.productCategories || this.productCategories.length === 0) {
        return "Loading...";
      }

      const selectedCategory = this.user.product_category;
      let selectedAppId = this.categoryIdMap[selectedCategory];

      let check = this.productCategories.find(
        (detail) => detail.product_category_code == selectedCategory
      );
      if (check) {
        selectedAppId = check.id;
      }

      if (selectedAppId) {
        const selectedApp = this.productCategories.find((app) => app.id === selectedAppId);
        return selectedApp ? selectedApp.name : "";
      } else {
        return "No App Selected";
      }
    },
  },
  methods: {
    setBadge(count) {
      this.$set(this.badges, "needsResubmission", Number(count) || 0);
    },
    handleShowFloatSubmenu: function (menu, offset) {
      this.$emit("showFloatSubmenu", menu, offset);
    },
    handleHideFloatSubmenu: function () {
      this.$emit("hideFloatSubmenu");
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.menus.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    handleSidebarMinify: function () {
      this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
    },

    async loadBadges() {
      const d = new Date();
      const period = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      try {
        const res = await this.$http.get("/api/data-submission/oil-maker/summary", {
          params: { period },
        });
        const body = res.data || {};
        const s = body.data && typeof body.data === "object" ? body.data : body;
        const k = s.kpi || {};
        this.$set(
          this.badges,
          "needsResubmission",
          (s.banner && s.banner.needs_resubmission_count) ||
            (k.needs_resubmission && k.needs_resubmission.count) ||
            0
        );
      } catch (e) {
      }
    },

    getModules() {
      let modules = JSON.parse(JSON.stringify(this.$store.state.modules));
      let userAccess = this.$store.getters.currentUser;

      if (userAccess.role.length == 0 || userAccess.role[0].id == 1) {
        // for superadmin
      } else if (userAccess.role[0].id == 2) {
        modules = [
          {
            code: null,
            icon: "fas fa-clipboard",
            path: "/work-order-listing",
            title: "List Work Order",
          },
        ];
      } else if (userAccess.role.length > 0) {
        let i = 0;
        while (modules[i]) {
          if (!modules[i].children) {
            if (userAccess.permissions.indexOf(modules[i].code) == -1) modules.splice(i, 1);
            else i++;
          } else {
            let j = 0;
            while (modules[i].children[j]) {
              if (userAccess.permissions.indexOf(modules[i].children[j].code) == -1)
                modules[i].children.splice(j, 1);
              else j++;
            }
            if (modules[i].children.length == 0) modules.splice(i, 1);
            else i++;
          }
        }
      }

      this.menus = modules;
    },

    async getAllApps() {
      try {
        // console.log(`masuk bos ${this.user.token}`);
        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        let resp = await this.$httpSSO.get("/api/admin/feeds/product-category", { headers });

        //console.log(JSON.stringify(resp.data.data));
        this.categoryIdMap = resp.data.data;

        // Save to Vuex global state
        this.$store.dispatch("setProductCategory", resp.data.data);

        // Update local productCategories from global state
        this.productCategories = resp.data.data;

        this.initializeCurrentApp();
      } catch (err) {
        console.error("Error fetching data:", err);
        // console.error("Error response status:", err.response.status);
        // console.error("Error response data:", err.response.data);
      }
    },

    initializeCurrentApp() {
      const selectedCategory = this.user.product_category;
      if (selectedCategory && this.categoryIdMap.length > 0) {
        const check = this.categoryIdMap.find(
          (detail) => detail.product_category_code == selectedCategory
        );
        if (check) {
          this.currentApp = check.id;
        }
      }
    },

    handleAppSwitch() {
      if (this.currentApp) {
        const selectedApp = this.switchApps.find((app) => app.id === this.currentApp);
        const token = this.user.token;
        const redirectUrl = `${selectedApp.url}/cross-client?product_category_id=${this.currentApp}&token=${token}`;

        // let redirectUrl;

        // if (this.currentApp === 1) {
        //   redirectUrl = `http://localhost:8081/cross-client?product_category_id=${this.currentApp}&token=${token}`;
        // } else {
        //   redirectUrl = `http://localhost:8082/cross-client?product_category_id=${this.currentApp}&token=${token}`;
        // }
        window.location.href = redirectUrl;
      } else {
        // console.log("No app selected.");
      }
    },
  },
};
</script>

<style scoped>
.switcher-apps {
  background-color: #f2f2f2;
  border-radius: 4px;
  padding: 4px 0;
  margin: 16px 20px 0;
  display: flex;
  align-items: center;
}

.switcher-apps > *:first-child {
  padding-left: 2px;
  flex-basis: 48px;
}
.switcher-apps > *:last-child {
  padding-right: 8px;
  flex-basis: 70%;
}

.switcher-apps span,
.switcher-apps select,
.switcher-apps option {
  color: #383838;
}

.switcher-apps select,
.switcher-apps option {
  width: 100%;
}

.switcher-apps span {
  font-weight: 400;
  padding-left: 4px;
}

.switcher-apps select {
  font-weight: 700;
  padding: 4px 0;
  border: 0;
  /* appearance: none; */
  background: none;
}

.application-list {
  display: flex;
  flex-direction: column;
}

.profile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.profile-pic {
  width: 48px;
  height: 48px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.profile-pic img {
  width: 100%;
}

.profile-pic + * {
  text-align: center;
}

.profile h4 {
  margin: 0;
}
</style>
